/**
 * API Configuration
 * Update the baseUrl to match your backend API endpoint
 */
export const API_CONFIG = {
  // Base URL for all API requests
  // Examples:
   baseUrl :'https://api.demo.yuktipluse.com' ,
  // baseUrl: 'https://localhost:7165/hcms' ,
  

  // - '/api' (relative to current domain)
  // baseUrl: 'https://api.example.com', // Update with your actual API base URL
  
  // API version prefix (optional)
  apiVersion: '/v1',
  
  // Whether to include API version in the URL
  useApiVersion: false,
  
  /**
   * Get the full base URL with optional version
   */
  getBaseUrl(): string {
    if (this.useApiVersion) {
      return `${this.baseUrl}${this.apiVersion}`;
    }
    return this.baseUrl;
  },
  
  /**
   * Check if URL is absolute (starts with http:// or https://)
   */
  isAbsoluteUrl(url: string): boolean {
    return /^https?:\/\//i.test(url);
  }
};


